import VerifyPhoneNumber from 'features/myVaro/screens/PersonalDetails/ChangePassword/VerifyPhoneNumber/VerifyPhoneNumber';
import React from 'react';

export default function EnterCodePage() {
  return <VerifyPhoneNumber />;
}
